import React from 'react'

import {
  Bulletins,
  Contract,
  FeatureFlag,
  User,
} from '../../../common/validations'

import { useAPIGetContractSuspense } from 'api/apiHooks/useAPIGetContract'
import { useAPIGetFeatureFlagsSuspense } from 'api/apiHooks/useAPIGetFeatureFlags'
import { useAPIGetUserProfileSuspense } from 'api/apiHooks/useAPIGetUserProfile'
import { useAPIGetBulletinsSuspense } from 'api/apiHooks/useAPIGetBulletins'
import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'

interface Data {
  contract: Contract
  user: User
  featureFlags: FeatureFlag
  bulletins: Bulletins
  hasMoreBulletins: boolean
}

export const DataLoader = ({
  children,
}: {
  children: (data: Data) => React.ReactNode
}) => {
  const { currentContractId } = useCurrentContract()
  const { data: contract } = useAPIGetContractSuspense(currentContractId)
  const { data: featureFlags } = useAPIGetFeatureFlagsSuspense()
  const { data: user } = useAPIGetUserProfileSuspense()
  const {
    data: { bulletins, hasMoreBulletins },
  } = useAPIGetBulletinsSuspense(currentContractId)

  return children({
    contract,
    user,
    featureFlags,
    bulletins,
    hasMoreBulletins,
  })
}
